import React, { useState } from "react";
import axios from "axios";
import config from "../config";
import FeatureCheckbox from "../components/FeatureCheckbox";

const AddAffirmation = () => {
  const [affirmation, setAffirmation] = useState("");
  const [reference, setReference] = useState("");
  const [addToFeature, setAddToFeature] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let validationErrors = {};
    if (!affirmation.trim()) validationErrors.affirmation = "Affirmation is required";
    if (!reference.trim()) validationErrors.reference = "Reference is required";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setErrors({});

    try {
      // Prepare plain JSON data (no file)
      const postData = {
        catId: 1, // set your category id here
        prayerType: "affirmation",
        title: affirmation,
        reference: reference,
        description: null, // optional
        numberOfTask: null, // optional
        file: null, // no file
        isFeatured: addToFeature,
      };

      const response = await axios.post(
        `${config.BASE_URL}/apis/create-post-admin`,
        postData
      );

      if (response.data.success) {
        alert("Affirmation created successfully!");
        setAffirmation("");
        setReference("");
        setAddToFeature(false);
      } else {
        alert("Failed to create affirmation: " + response.data.message);
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while creating affirmation.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-10 bg-white shadow-md rounded-md">
      <div className="bg-orange-500 text-white px-4 py-3 rounded-t-md">
        <h2 className="font-semibold">Add New Affirmation</h2>
      </div>

      <div className="p-6">
        <form onSubmit={handleSubmit} noValidate>
          <div className="mb-4">
            <label htmlFor="affirmation" className="block text-gray-700 font-medium mb-1">
              Affirmation
            </label>
            <input
              id="affirmation"
              type="text"
              placeholder="Enter Affirmation"
              value={affirmation}
              onChange={(e) => setAffirmation(e.target.value)}
              className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 ${
                errors.affirmation ? "border-red-500" : "border-gray-300"
              }`}
              required
            />
            {errors.affirmation && (
              <p className="text-red-500 text-sm mt-1">{errors.affirmation}</p>
            )}
          </div>

          <div className="mb-6">
            <label htmlFor="reference" className="block text-gray-700 font-medium mb-1">
              Reference
            </label>
            <input
              id="reference"
              type="text"
              placeholder="Enter Reference"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 ${
                errors.reference ? "border-red-500" : "border-gray-300"
              }`}
              required
            />
            {errors.reference && (
              <p className="text-red-500 text-sm mt-1">{errors.reference}</p>
            )}
          </div>

          <div className="mb-4 flex flex-wrap items-center justify-between gap-4">
            <FeatureCheckbox checked={addToFeature} onChange={setAddToFeature} disabled={loading} />
            <button
              type="submit"
              disabled={loading}
              className={`bg-orange-500 text-white font-semibold px-6 py-2 rounded hover:bg-orange-600 transition ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {loading ? "Adding..." : "Add"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAffirmation;
